// "İlgili Kullanıcı" seçeneklerinde tüm aktif sistem kullanıcıları listelenir.
// (Daha önce sabit bir e-posta izin listesi vardı; kaldırıldı.)
export const filterRelatedUsers = (users = []) =>
  (users || []).filter((u) => u && u.isActive !== false);
